import MintTokens from "../../../components/actions/NFTs/mintTokens";
const MintErc721 = () => {
  return (
    <>
      <MintTokens tokenType="Erc721" />
    </>
  );
};

export default MintErc721;